"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FINANCIAL_ADVANCE_DEPOSIT_REQUEST_EXAMPLES = exports.settleDepositRequestSchema = exports.debitAdvanceDepositRequestSchema = exports.creditAdvanceDepositRequestSchema = void 0;
/**
 * Request contracts for the 3 Advance/Deposit endpoints —
 * `AdvanceDepositApplicationService.credit`/`.debit`/`.settle`
 * (`backend/src/modules/financial/application/advance-deposit.application-service.ts`,
 * frozen, Stage 5C.3). One Domain Service backs both the "Advance"
 * and "Deposit" named categories (differentiated only by
 * `FinAdvanceDepositAccount.accountType`, Stage 5C.2/5C.3's own
 * consolidation decision) — `creditAdvanceDeposit`/`debitAdvanceDeposit`
 * cover both; `settleDeposit` is deposit-only (the Domain Service
 * itself rejects `OPD_ADVANCE` accounts).
 */
const zod_1 = require("zod");
const financial_common_request_1 = require("./financial-common.request");
exports.creditAdvanceDepositRequestSchema = zod_1.z.object({
    accountId: zod_1.z.string().uuid(),
    amount: zod_1.z.number().int().positive(),
    paymentId: zod_1.z.string().uuid().optional(),
    remarks: zod_1.z.string().optional(),
    ...financial_common_request_1.financialWorkflowExtrasShape,
});
exports.debitAdvanceDepositRequestSchema = exports.creditAdvanceDepositRequestSchema;
exports.settleDepositRequestSchema = zod_1.z.object({
    accountId: zod_1.z.string().uuid(),
    remarks: zod_1.z.string().optional(),
    ...financial_common_request_1.financialWorkflowExtrasShape,
});
exports.FINANCIAL_ADVANCE_DEPOSIT_REQUEST_EXAMPLES = {
    creditAdvanceDeposit: {
        accountId: '66666666-6666-6666-6666-666666666666',
        amount: 100000,
        remarks: 'Admission deposit',
    },
    debitAdvanceDeposit: {
        accountId: '66666666-6666-6666-6666-666666666666',
        amount: 50000,
        remarks: 'Applied against OPD charge',
    },
    settleDeposit: {
        accountId: '66666666-6666-6666-6666-666666666666',
        remarks: 'IPD discharge settlement',
    },
};
//# sourceMappingURL=financial-advance-deposit.request.js.map